import React from "react";

const Bone = ({ className = "" }) => (
  <span className={`study-dashboard-skeleton__bone ${className}`.trim()} />
);

const StudyDashboardSkeleton = () => {
  return (
    <div
      className="study-dashboard study-dashboard--skeleton"
      aria-busy="true"
      aria-label="Loading dashboard"
    >
      <div className="study-dashboard__header">
        <Bone className="study-dashboard-skeleton__greeting" />
      </div>

      <div className="study-dashboard__main-grid">
        <div className="study-dashboard__primary">
          <div className="study-dashboard__goal-row">
            <div className="study-dashboard-skeleton__card">
              <Bone className="study-dashboard-skeleton__label" />
              <Bone className="study-dashboard-skeleton__value" />
              <Bone className="study-dashboard-skeleton__bar" />
            </div>
            <div className="study-dashboard-skeleton__card">
              <Bone className="study-dashboard-skeleton__label" />
              <Bone className="study-dashboard-skeleton__value" />
              <Bone className="study-dashboard-skeleton__bar" />
            </div>
          </div>

          <div className="study-dashboard-skeleton__card study-dashboard-skeleton__weekly">
            <Bone className="study-dashboard-skeleton__label" />
            <div className="study-dashboard-skeleton__stat-row">
              <Bone className="study-dashboard-skeleton__stat" />
              <Bone className="study-dashboard-skeleton__stat" />
              <Bone className="study-dashboard-skeleton__stat" />
            </div>
          </div>

          <div className="study-dashboard-skeleton__resume">
            <Bone className="study-dashboard-skeleton__resume-pill" />
            <Bone className="study-dashboard-skeleton__resume-title" />
            <div className="study-dashboard-skeleton__resume-track">
              {Array.from({ length: 4 }).map((_, index) => (
                <div className="study-dashboard-skeleton__resume-card" key={index}>
                  <Bone className="study-dashboard-skeleton__resume-line" />
                  <Bone className="study-dashboard-skeleton__resume-line study-dashboard-skeleton__resume-line--short" />
                  <Bone className="study-dashboard-skeleton__resume-button" />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="study-dashboard__sidebar">
          <div className="study-dashboard-skeleton__card study-dashboard-skeleton__leaderboard">
            <Bone className="study-dashboard-skeleton__label" />
            {Array.from({ length: 5 }).map((_, index) => (
              <div className="study-dashboard-skeleton__lb-row" key={index}>
                <Bone className="study-dashboard-skeleton__avatar" />
                <Bone className="study-dashboard-skeleton__lb-name" />
              </div>
            ))}
          </div>
        </div>

        <div className="study-dashboard__quick-actions-wrap">
          <div className="study-dashboard-skeleton__chips">
            {Array.from({ length: 4 }).map((_, index) => (
              <Bone className="study-dashboard-skeleton__chip" key={index} />
            ))}
          </div>
          <Bone className="study-dashboard-skeleton__section-title" />
          <div className="study-dashboard-skeleton__actions">
            {Array.from({ length: 4 }).map((_, index) => (
              <Bone className="study-dashboard-skeleton__action" key={index} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudyDashboardSkeleton;
